import 'phaser'
import {
    CST
} from '../CST'

export default class EndScreen extends Phaser.Scene {
    constructor() {
        super(CST.SCENES.ENDSCREEN);
    }

    preload() {

    }

    create(data) {
        this.clickSound = this.sound.add("click-sound");

        const totalSexist = data.points + data.sexistMissed;

        const totalNonSexist = data.nonSexistCount + data.nonSexistMissed

        this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'bubble-outro');

        if (data.points >= 10) {
            this.add.text(this.cameras.main.width / 2 - 600, this.cameras.main.height / 2 - 160, data.points + " / " + totalSexist + " ", CST.TEXTSTYLES.ENDSCREENTEXT);
        } else {
            this.add.text(this.cameras.main.width / 2 - 600, this.cameras.main.height / 2 - 160, data.points + " / " + totalSexist, CST.TEXTSTYLES.ENDSCREENTEXT);
        }

        this.add.text(this.cameras.main.width / 2 - 600, this.cameras.main.height / 2 + 40, Math.round(data.points / totalSexist * 100) + "%", CST.TEXTSTYLES.ENDSCREENTEXT);


        if (data.sexistMissed >= 10) {
            this.add.text(this.cameras.main.width / 2 - 110, this.cameras.main.height / 2 - 160, data.sexistMissed + " / " + totalSexist + " ", CST.TEXTSTYLES.ENDSCREENTEXT);
        } else {
            this.add.text(this.cameras.main.width / 2 - 110, this.cameras.main.height / 2 - 160, data.sexistMissed + " / " + totalSexist, CST.TEXTSTYLES.ENDSCREENTEXT);
        }

        this.add.text(this.cameras.main.width / 2 - 85, this.cameras.main.height / 2 + 40, Math.round(data.sexistMissed / totalNonSexist * 100) + "%", CST.TEXTSTYLES.ENDSCREENTEXT);

        if (data.nonSexistCount >= 10) {
            this.add.text(this.cameras.main.width / 2 + 350, this.cameras.main.height / 2 - 160, data.nonSexistCount + " / " + totalNonSexist + " ", CST.TEXTSTYLES.ENDSCREENTEXT);
        } else {
            this.add.text(this.cameras.main.width / 2 + 350, this.cameras.main.height / 2 - 160, data.nonSexistCount + " / " + totalNonSexist, CST.TEXTSTYLES.ENDSCREENTEXT);
        }

        this.add.text(this.cameras.main.width / 2 + 370, this.cameras.main.height / 2 + 40, Math.round(data.nonSexistCount / totalNonSexist * 100) + "%", CST.TEXTSTYLES.ENDSCREENTEXT);

        this.menu_btn = this.add.image(1425, 55, 'menu-button-bubbles').setScale(.7).setDepth(1.2).setInteractive({
            useHandCursor: true
        }).on('pointerdown', () => {
            this.menu_btn.setTexture('menu-button-bubbles');
        }).on('pointerup', () => {
            this.clickSound.play();
            this.menu_btn.setTexture('menu-button');
            location.reload();
        })

        this.next_btn = this.add.image(1400, 830, 'next-button-orange').setInteractive({
            useHandCursor: true
        }).on('pointerdown', () => {
            this.scene.start(CST.SCENES.QUIZ, {
                User_ID: data.User_ID
            })
        })
    }
}